enum ToothNumberingSystem {
  'FDI' = 'FDI',
  'UNIVERSAL' = 'UNIVERSAL',
  'PALMER' = 'PALMER',
}

export { ToothNumberingSystem }
